// @ts-strict-ignore
import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box, DataListItem } from '@node-space/ui-components'
import type { Transaction } from 'types/transaction'
import { getSupportedPaymentTypes } from 'utils/utils'

interface InternalTransferSenderReceiverProps {
  beneficiary?: string
  sender?: string
  transactionTypeSubType: string
  transactionDetails?: Transaction
}

const supportedPaymentTypes = getSupportedPaymentTypes()

const InternalTransferSenderReceiver = ({
  beneficiary,
  sender,
  transactionTypeSubType,
  transactionDetails,
}: InternalTransferSenderReceiverProps) => {
  const { t } = useTranslation()
  const isCryptoTransaction = !transactionDetails?.wallet?.currency?.fiat

  const details = useMemo(() => {
    switch (transactionTypeSubType) {
      case supportedPaymentTypes.BVNK_NETWORK_TRANSFER_PAYMENT_OUT:
        return {
          title: t('withdrawalDetails'),
          beneficiaryOrSenderLabel: t('transactions.sideBar.bvnkNetworkMember'),
          beneficiaryOrSender: beneficiary,
        }
      case supportedPaymentTypes.BVNK_NETWORK_TRANSFER_PAYMENT_IN:
        return {
          title: t('senderDetails'),
          beneficiaryOrSenderLabel: t('transactions.sideBar.bvnkNetworkMember'),
          beneficiaryOrSender: sender,
        }
      case supportedPaymentTypes.INTERNAL_TRANSFER_PAYMENT_OUT:
        return {
          title: t('withdrawalDetails'),
          beneficiaryOrSenderLabel: t('transactions.sideBar.beneficiary'),
          beneficiaryOrSender: beneficiary,
        }
      case supportedPaymentTypes.INTERNAL_TRANSFER_PAYMENT_IN:
        return {
          title: t('senderDetails'),
          beneficiaryOrSenderLabel: t('transactions.sideBar.sender'),
          beneficiaryOrSender: sender,
        }
    }
  }, [transactionTypeSubType, beneficiary, sender, t])

  return (
    !!details && (
      <>
        <p className="text-h4 text-foreground-prominent mt-3">{details?.title}</p>
        <Box gapY={8}>
          <DataListItem
            id="beneficiary-or-sender"
            testId="beneficiary-or-sender"
            title={details?.beneficiaryOrSenderLabel}
            body={details?.beneficiaryOrSender}
          />
        </Box>

        {isCryptoTransaction && (
          <>
            <p className="text-h4 text-foreground-prominent mt-3">
              {t('transactions.sideBar.beneficiaryDetails')}
            </p>
            <DataListItem
              id="beneficiary-details"
              testId="beneficiary-details"
              title={t('transactions.sideBar.beneficiary')}
              body={beneficiary}
            />
          </>
        )}
      </>
    )
  )
}

export default InternalTransferSenderReceiver
